(function($) {
$(document).ready(function(){
  function rgb2hex(rgb){
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? "#" +
     ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
     ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
     ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
   }

   $('#sliderWrapper').addClass('swiper-container').append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
   $('#sliderWrapper > .e-con-inner').addClass('swiper-wrapper');
   $('#sliderWrapper > .e-con-inner > .elementor-element').addClass('swiper-slide');
   setTimeout(() => {
    $('#sliderWrapper > .swiper-wrapper').removeClass('e-con-inner');
    var mySwiper = new Swiper("#sliderWrapper", {
        spaceBetween: 1,
        slidesPerView: 1,
        centeredSlides: true,
        roundLengths: true,
        loop: true,
        initialSlide: 1,
        loopAdditionalSlides: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            768: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 3,
            },
          },
      });
   }, 500);

   var index = window.location.href.indexOf('?');
   if(index != -1){
        var querystring = window.location.href.slice(index + 1);
        var tagA = document.getElementsByTagName('a');
        for(var i = 0; i < tagA.length; i++){
            var href = tagA[i].getAttribute('href');
      if(href !==null){
        if(href.trim() != '#' && href.trim().indexOf('elementor-action') === -1 ){
          if(href.trim().indexOf('tel:') === -1 && href.trim().indexOf('mailto:') === -1){
            href += (href.indexOf('?') != -1)? '&' : '?';
            href += querystring;
          }
        }
        tagA[i].setAttribute('href', href);
      }
        }
    }
    if($('#verifyInsuranceBtn').length){
      $(document).on('click','#verifyInsuranceBtn',function(e){
        e.preventDefault();
        var index = window.location.href.indexOf('?');
        var lp_url = $(this).attr('href');
			  var section_id = lp_url;
        if(index != -1){
          var lp_hash = lp_url.substring(lp_url.indexOf('#'));
          section_id = '#' + lp_hash.substr(1,lp_hash.indexOf('?')).replace('?', '');
        }
        if(lp_url.indexOf('?') != -1){
          var lp_hash = lp_url.substring(lp_url.indexOf('#'));
          section_id = '#' + lp_hash.substr(1,lp_hash.indexOf('?')).replace('?', '');
        }
        var section_offset = 100;
        var el_target = $(section_id.trim()).offset().top - section_offset;
			  $('html, body').animate({scrollTop:el_target}, 500);
      });
    }
    if($('#lpmobileMenu').length){
      $(document).on('click','#lpmobileMenu .elementor-icon-list-item a',function(e){
        e.preventDefault();
        console.log($(this).attr('href'));
        var index = window.location.href.indexOf('?');
        var lp_url = $(this).attr('href');
			  var section_id = lp_url;
        if(index != -1){
          var lp_hash = lp_url.substring(lp_url.indexOf('#'));
          section_id = '#' + lp_hash.substr(1,lp_hash.indexOf('?')).replace('?', '');
        }
        if(lp_url.indexOf('?') != -1){
          var lp_hash = lp_url.substring(lp_url.indexOf('#'));
          section_id = '#' + lp_hash.substr(1,lp_hash.indexOf('?')).replace('?', '');
        }
        var section_offset = 100;
        var el_target = $(section_id.trim()).offset().top - section_offset;
        setTimeout(function(){
          $('.dialog-close-button.dialog-lightbox-close-button').click();
        },500);
			  $('html, body').animate({scrollTop:el_target}, 500);
      });
    }

    var lastScrollTop = 0, delta = 10;
    $(window).scroll(function() {
      /*if($('.elementor-popup-modal').is(":visible")){
        $('.dialog-close-button').click();
      }*/
      var st = $(this).scrollTop();
		  if(Math.abs(lastScrollTop - st) <= delta)
		   return;
      if (st > lastScrollTop){
        $('.logo-burger.landing-page').css({'height':'40px'});
        $('.logo-burger.landing-page').css({'overflow':'hidden'});
        $('.logo-burger.landing-page.site-wide').css({'height':'50px'});
        $('.logo-burger.landing-page.site-wide').css({'overflow':'hidden'});
      }else {
        $('.logo-burger.landing-page').css({'height':''});
        $('.logo-burger.landing-page').css({'overflow':''});
      }
      lastScrollTop = st;
      if ($(window).scrollTop() > 50){
        $('header').addClass('is-sticky');
        var header_height = ($('header').height() + $('#facilityLocationFilter').height()) - 40;
        if($('body').hasClass('admin-bar')){
          header_height = ($('body').find('header:first').height() + $('#facilityLocationFilter').height());
        }
        if($(window).width() <= 1024 && $(window).width() > 768 ){
          $('#facilityLocationFilter').css({'position':'fixed'}); 
          $('#facilityLocationFilter').css({'width':'auto'});
          $('#facilityLocationFilter').css({'margin-top':'0'});
          $('#facilityLocationFilter').css({'margin-bottom':'0'});
          $('#facilityLocationFilter').css({'top': header_height + 'px'});
          $('#facilityLocationFilter').css({'inset-inline-start': (($(window).width() - $('.facility-filter-control-sc').width()) - 10) + 'px'});
          $('#facilityLocationFilter').css({'padding-left': '10px'});
          $('#facilityLocationFilter').css({'bacground': '#fff'});
          $('#facilityLocationFilter').css({'box-shadow': '0px 0px 20px 0px rgba(0, 0, 0, 0.1)'});
        }
        if($(window).width() <= 768 ){
          $('#facilityLocationFilter').css({'position':'fixed'});
          $('#facilityLocationFilter').css({'width': $(window).width() + 'px'});
          $('#facilityLocationFilter').css({'margin-top':'0'});
          $('#facilityLocationFilter').css({'margin-bottom':'0'});
          $('#facilityLocationFilter').css({'top' : header_height + 'px'});
          $('#facilityLocationFilter').css({'inset-inline-start': ''});
          $('#facilityLocationFilter').css({'bacground': ''});
          $('#facilityLocationFilter').css({'box-shadow': ''});
          $('#facilityLocationFilter').css({'left': '0'});
        }
      }else{
        $('header').removeClass('is-sticky');
        $('#facilityLocationFilter').css({'position':''});
          $('#facilityLocationFilter').css({'width':''});
          $('#facilityLocationFilter').css({'margin-top':''});
          $('#facilityLocationFilter').css({'margin-bottom':''});
          $('#facilityLocationFilter').css({'top' : ''});
          $('#facilityLocationFilter').css({'inset-inline-start': ''});
          $('#facilityLocationFilter').css({'bacground': ''});
          $('#facilityLocationFilter').css({'box-shadow': ''});
          $('#facilityLocationFilter').css({'left': ''});
      }
    });

    $('header').css({'width':$(window).width()+'px'});
    $(window).resize(function() {
      $('header').css({'width':$(window).width()+'px'});
    });
    $(':root').css('--screen-width', $(window).width() + 'px');
    $(window).resize(function() {
      $(':root').css('--screen-width', $(window).width() + 'px');
    });

    $(document).on('click', '.facility-filter-control-sc .selected-filer', function(e){
      e.preventDefault();
      //$(this).parent().parent().find('.filtiers').toggleClass('screen-hide-section');
      if($(this).parent().parent().find('.filtiers').hasClass('screen-hide-section')){
        $(this).parent().parent().find('.filtiers').removeClass('screen-hide-section');
        $('body').prepend('<div class="facility-filter-overlay"></div>');
      }else{
        $(this).parent().parent().find('.filtiers').addClass('screen-hide-section');
        $('.facility-filter-overlay').remove();
      }
    });

    $(document).on('click','.facility-filter-overlay', function(){
      $('.facility-filter-control-sc .selected-filer').click();
    });

    window.onkeyup = function (event) {
      if(event.keyCode == 27){
        //$('.facility-filter-control-sc .selected-filer').click();
        if(!$('.facility-filter-control-sc .filtiers').hasClass('screen-hide-section')){
          $('.facility-filter-control-sc .filtiers').addClass('screen-hide-section');
          $('.facility-filter-overlay').remove();
        }
      }
    }
    if($('#desktopfacilitygallery2').length){
      $('#desktopfacilitygallery2 .facility-thumb-nails-style2').find('.swiper-slide').each(function(){
        $(this).find('img').css({'cursor':'pointer'});
        $(this).find('img').on({
          mouseenter: function () {
             $(this).css({'borderColor':'#D67E2B'});
          },
          mouseleave: function () {
            if(!$(this).hasClass('current-active')){
              $(this).css({'borderColor':''});
            }
          }
      });
        $(this).find('img').on('click',function(){
          //console.log($(this).attr('src'));
          var selected_image_parent = $(this).parent().parent().parent();
          selected_image_parent.find('img').removeClass('current-active');
          selected_image_parent.find('img').css({'borderColor':''});
          var selected_image = $(this);
          var clicked_facility_img_src = $(this).attr('src');
          var clicked_facility_img_src_set =  $(this).attr('srcset');
          $('#desktopfacilitygallery2 .facility-main-image-style2').find('img').fadeOut('fast', function () {
            $('#desktopfacilitygallery2 .facility-main-image-style2').find('img').attr('src',clicked_facility_img_src);
            $('#desktopfacilitygallery2 .facility-main-image-style2').find('img').attr('srcset',clicked_facility_img_src_set);
            $('#desktopfacilitygallery2 .facility-main-image-style2').find('img').fadeIn('fast');
            selected_image.css({'borderColor':'#D67E2B'});
            selected_image.addClass('current-active');
          });
        });
      });
    }
    if($('#marqueeContainer').length){
      const toLeftDir = [];
      const toRightDir = [];
      $('#marqueeToLeft').find('img').each(function(){
        toLeftDir.push($(this).parent().html());
      });
      $('#marqueeToLeft').html('');
      $.each(toLeftDir,function(idx, img){
        $('#marqueeToLeft').append(img);
      });

      $('#marqueeToRight').find('img').each(function(){
        toRightDir.push($(this).parent().html());
      });
      $('#marqueeToRight').html('');
      $.each(toRightDir,function(idx, img){
        $('#marqueeToRight').append(img);
      });

      $('#marqueeToLeft').marquee({
          direction:'left',
          duration: 100000,
          gap: 0,
          delayBeforeStart: 0,
          duplicated: true,
          startVisible: true
      });
      $('#marqueeToRight').marquee({
          direction:'right',
          duration: 100000,
          gap: 0,
          delayBeforeStart: 0,
          duplicated: true,
          startVisible: true
      });
    }
    var curentWindpwWidth = $(window).width();
    $(window).resize(function() {
      curentWindpwWidth = $(window).width();
    });

    if($('#footerAccreditation').length && curentWindpwWidth <= 768 ){
      const toLeftDirf = [];
      $('#footerAccreditation').find('img').each(function(){
        toLeftDirf.push($(this).parent().html());
      });
      $('#footerAccreditation').html('');
      $.each(toLeftDirf,function(idx, img){
        $('#footerAccreditation').append(img);
      });
      $('#footerAccreditation').marquee({
          direction:'left',
          duration: 100000,
          gap: 60,
          delayBeforeStart: 0,
          duplicated: true,
          startVisible: true
      });
    }
    if($('.quote-section').length){
      $('.quote-section').each(function(e){
        if($(this).find('.elementor-widget-testimonial-carousel').find('.swiper-slide:first').length){
          var quotecolor = $(this).find('.elementor-widget-testimonial-carousel').find('.swiper-slide:first').find('.elementor-testimonial__text').eq(0).css('color');
          $(this).css({'--quote-icon-color' : rgb2hex(quotecolor)});
        }
      });
    }
});
})(jQuery);